var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"dkzc-box min400"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.titleList[_vm.$route.query.type - 3]))]),_c('div',{staticClass:"vhtml",domProps:{"innerHTML":_vm._s(_vm.content.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }